<template>
  <div>
    <section class="round_ended">
      <div class="round_ended__head">
        <div class="round_ended__head__top">
          <h1>{{ isCurrentRoundWinner ? getTranslations.home_round_ended_you_won : getTranslations.home_round_ended_you_lost }} {{ currentRoundNumber }} !</h1>
        </div>
        <div class="round_ended__head__bottom">
          <div class="round_ended__head__bottom__player round_ended__head__bottom__player--p1">
            <img :src="playersDetails.homePlayerAvatar" alt="">
            <span>{{ playersDetails.homePlayerUsername }}</span>
            <ul class="player_score player_score left_player">
              <li v-for="(item, index) in numberOfQuestionsPerRound" :key="index" :class="getHomePlayerAnswersHistory(index)"></li>
            </ul>
          </div>
          <div class="round_ended__head__bottom__player round_ended__head__bottom__player--p2">
            <img :src="playersDetails.awayPlayerAvatar" alt="">
            <span>{{ playersDetails.awayPlayerUsername }}</span>
            <ul class="player_score player_score right_player">
              <li v-for="(item, index) in numberOfQuestionsPerRound" :key="index" :class="getAwayPlayerAnswersHistory(index)"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="round_ended__center-score">
        <p><span class="p1">{{ homePlayerRoundScore }}</span>-<span>{{ awayPlayerRoundScore }}</span> </p>
      </div>
      <div class="round_ended__bottom">
        <h2 v-if="isEqualAmountOfCorrectAnswers && isCurrentRoundWinner">{{ getTranslations.home_round_ended_you_were_faster }}</h2>
        <h2 v-if="isEqualAmountOfCorrectAnswers && !isCurrentRoundWinner">{{ getTranslations.home_round_ended_you_were_slower }}</h2>
        <div v-if="isEqualAmountOfCorrectAnswers" class="donut-chart donut-chart--speed">
          <div class="games-left donut-chart__info">{{ homePlayerTotalAnswerTimeInSec }} ''</div>
          <div id="speed_answering_chart" class="donut-size donut-cont">
            <div class="pie-wrapper">
              <span class="label">
                <span class="smaller">{{ getTranslations.home_round_ended_answer_speed }}</span>
              </span>
              <div class="pie">
                <div class="left-side half-circle"></div>
                <div class="right-side half-circle"></div>
              </div>
              <div class="shadow"></div>
            </div>
          </div>
          <div class="games-played donut-chart__info">{{ awayPlayerTotalAnswerTimeInSec }} ''</div>
        </div>
      </div>
      <fade-transition>
        <component :is="modalForHomePage" @close="closeModalValidationsRoundEnded" @playPostGameAddOn="playPostGameAddOn"></component>
      </fade-transition>
      <fade-transition>
        <component :is="modalForChallenge" v-if="gameFinished" @close="closeModalValidationsChallenge"></component>
      </fade-transition>
    </section>
  </div>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }], curly: [2 , "multi-line"] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { pieChartAnimation } from '@/common/jQuery';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import PostGame from '@/components/home/modals/PostGame';
import ServicePromotion from '@/components/home/modals/ServicePromotion';
import LevelUp from '@/components/home/modals/LevelUp';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import { RematchMixin, BeforeDestroyRematch } from '@/common/mixins/rematch/rematch';

export default {
  name: 'round-ended',
  mixins: [ParseResponseMixin, ParseResponseMixin, GameMixin2, RematchMixin, BeforeDestroyRematch],
  emits: ['close'],
  components: {
    PostGame,
    FadeTransition,
  },
  data() {
    return {
      showedModal: false,
      userLevel: 0,
      bonusPoints: 0,
      gamesEarned: 0,
      playAddOnGame: false,
      timeout: null,
    };
  },
  created() {
    if (this.gameFinished) {
      this.subscribeUserForOnlineChannelAndThenOpenTheChannel({ statusOnline: true });
      this.rematchWithSpecificUser();
      this.timeout = setTimeout(() => {
        this.subscribeUserForOnlineChannelAndThenOpenTheChannel({ statusOnline: false });
      }, 30000);
    }
  },
  mounted() {
    console.log('in RoundEnded mounted hook:');
    console.log(`isCurrentRoundWinner: ${this.isCurrentRoundWinner}`);
    if (this.isEqualAmountOfCorrectAnswers) {
      setTimeout(() => {
        pieChartAnimation('#speed_answering_chart', this.getAnswerTimeRatio());
      }, 350);
    }
    if (this.servicePromotionModal && this.gameFinished) {
      this.getUserLoginDetails().then(() => {
        if (this.userDetails.gamesPlayed === 1) {
          this.storeModalForHomePage(ServicePromotion);
          console.log('showing service promotion pop up');
          this.showedModal = true;
        } else {
          setTimeout(() => {
            if (this.gameFinished) {
              // wait 5 secs and show post game modal
              this.storeModalForHomePage(PostGame);
              console.log('showing post game modal...');
            } else {
              this.increaseCurrentRoundNumberbyOne();
              this.normalTransition = true;
              console.log('going to next round...');
              this.$router.push('/selectTheme');
            }
          }, 5000);
        }
      });
    } else {
      setTimeout(() => {
        if (this.gameFinished) {
          // wait 5 secs and show post game modal
          this.storeModalForHomePage(PostGame);
          console.log('showing post game modal...');
        } else {
          this.increaseCurrentRoundNumberbyOne();
          this.normalTransition = true;
          console.log('going to next round...');
          this.$router.push('/selectTheme');
        }
      }, 5000);
    }
  },
  beforeDestroy() {
    if (this.gameFinished) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
    this.initNextRoundData();
    this.storeModalForHomePage(null);
    this.storeModalForChallenge(null);
    if (this.notificationSubscription) this.notificationSubscription.unsubscribe();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeModalForChallenge',
    ]),
    ...mapActions('profile', [
      'getUserNotifications',
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'increaseCurrentRoundNumberbyOne',
      'setCurrentQuestionNumber',
      'resetPlayersAnswersHistoryCSSClasses',
    ]),
    ...mapMutations('profile', [
      'setShowmodalForLevelUp',
    ]),
    initNextRoundData() {
      console.log('initializing data for next round');
      this.setCurrentQuestionNumber(0);
      this.resetPlayersAnswersHistoryCSSClasses();
    },
    playPostGameAddOn() {
      this.normalTransition = true;
      console.log('TRUEEEEE');
      console.log('GAMEID:', this.gameID);
      this.getUserLoginDetails().then(() => {
        console.log('GAMEID:', this.gameID);
        this.$router.push({
          name: 'postGameAddOn',
          params: {
            gameId: this.gameID,
            correctAnswers: this.homePlayerCorrectAnswersCSSClasses.filter(answer => answer === 'correct').length,
          },
        });
      });
    },
    closeModalValidationsChallenge() {
      this.storeModalForChallenge(null);
    },
    closeModalValidationsRoundEnded() {
      // eslint-disable-next-line
      console.log('RoundEnded' + this.userLeveledUp + this.showedModal);
      if (this.userLeveledUp && !this.showedModal) {
        const notificationLevelupData = {
          userLevel: this.isHomePlayer ? this.homePlayerLevel : this.awayPlayerLevel,
          bonusPoints: this.isHomePlayer ? this.homePlayerLevelUpBonusPoints : this.awayPlayerLevelUpBonusPoints,
          gamesEarned: this.isHomePlayer ? this.homePlayerGamesEarned : this.awayPlayerGamesEarned,
        };
        console.log(`We have a special Notification ${notificationLevelupData}`);
        console.log(`We have a special Notification type with DATA: ${notificationLevelupData.userLevel}`);
        this.setShowmodalForLevelUp({ notificationLevelupObject: notificationLevelupData });
        this.getUserLoginDetails().then(() => {
          this.storeModalForHomePage(LevelUp);
          this.showedModal = true;
          console.log('showing level up pop up');
        });
      } else {
        console.log('user has not leveled up, going to home page');
        this.storeModalForHomePage(null);
        if (this.getUserAvailableGames === 0) {
          sessionStorage.removeItem('zeroBalancePopUp');
        }
        this.getUserLoginDetails().then(() => {
          this.$router.push('/home');
        });
      }
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
    getAwayPlayerAnswersHistory(answerIndex) {
      const awayPlayerAnswersHistory = this.awayPlayerCorrectAnswersCSSClasses[answerIndex];
      return awayPlayerAnswersHistory !== undefined ? awayPlayerAnswersHistory : '';
    },
    getAnswerTimeRatio() {
      return (this.awayPlayerRoundAnswerTime / (this.homePlayerRoundAnswerTime + this.awayPlayerRoundAnswerTime)) * 100;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'modalForChallenge',
      'modalForHomePage',
      'servicePromotionModal',
    ]),
    ...mapState('game', [
      'numberOfQuestionsPerRound',
      'homePlayerLevel',
      'awayPlayerLevel',
      'gameID',
      'playersDetails',
      'currentRoundNumber',
      'homePlayerRoundScore',
      'awayPlayerRoundScore',
      'gameFinished',
      'userLeveledUp',
      'homePlayerCorrectAnswersCSSClasses',
      'homePlayerRoundAnswerTime',
      'awayPlayerCorrectAnswersCSSClasses',
      'awayPlayerRoundAnswerTime',
      'awayPlayerGamesWon',
      'awayPlayerLevelUpBonusPoints',
      'homePlayerLevelUpBonusPoints',
      'homePlayerGamesWon',
      'homePlayerGamesEarned',
      'awayPlayerGamesEarned',
    ]),
    ...mapGetters('game', [
      'isCurrentRoundWinner',
      'isEqualAmountOfCorrectAnswers',
      'isHomePlayer',
      'isGameWinner',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
    ]),
    homePlayerTotalAnswerTimeInSec() {
      return (this.homePlayerRoundAnswerTime / 1000.0).toFixed(1);
    },
    awayPlayerTotalAnswerTimeInSec() {
      return (this.awayPlayerRoundAnswerTime / 1000.0).toFixed(1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/RoundEnded.vue